import * as React from "react"
import {ImageSeeker} from "@ui-seeker/core";
import {Box, Typography} from "@mui/material";

import {CheckIcon} from "../@components";


export default function ProductPagesImagesDetailSelectedImage({ url, text, checkerID=null, showIcon }) {

	return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative' }}>
		<Typography variant="overline" sx={{ fontStyle: 'italic', textAlign: 'center', my: 1 }}>
			{text}
		</Typography>
		<CheckIcon show={showIcon} status={checkerID} size="2rem" />
		<ImageSeeker src={url} sx={{ height: 550, alignSelf: 'flex-end' }} defaultImage="/images/defaultImage.png" />
	</Box>
}